import React from 'react'
import { authApi } from '../api/auth'
import { agreementsApi } from '../api/agreements'

const AuthContext = React.createContext(null)

export function AuthProvider({ children }) {
    const [user, setUser] = React.useState(() => {
        try { return JSON.parse(localStorage.getItem('bankroll_user')) } catch { return null }
    })
    const [pendingAgreements, setPendingAgreements] = React.useState([])

    // Listen for 401s from the API client
    React.useEffect(() => {
        const handle = () => { setUser(null); setPendingAgreements([]) }
        window.addEventListener('bankroll:logout', handle)
        return () => window.removeEventListener('bankroll:logout', handle)
    }, [])

    async function _fetchPending() {
        try {
            const pending = await agreementsApi.getPending()
            setPendingAgreements(pending)
        } catch {
            setPendingAgreements([])
        }
    }

    async function login(username, password) {
        const { access_token } = await authApi.login(username, password)
        localStorage.setItem('bankroll_token', access_token)
        const userData = await authApi.me()
        localStorage.setItem('bankroll_user', JSON.stringify(userData))
        setUser(userData)
        await _fetchPending()
        return userData
    }

    async function register(username, email, password, firstName, lastName, city, country, language, dateOfBirth) {
        await authApi.register(username, email, password, firstName, lastName, city, country, language, dateOfBirth)
        return login(username, password)
    }

    async function updateProfile(fields) {
        const userData = await authApi.updateProfile(fields)
        localStorage.setItem('bankroll_user', JSON.stringify(userData))
        setUser(userData)
        return userData
    }

    async function dismissAgreement(agreementId) {
        await agreementsApi.acknowledge(agreementId)
        setPendingAgreements(prev => prev.filter(a => a.id !== agreementId))
    }

    function logout() {
        localStorage.removeItem('bankroll_token')
        localStorage.removeItem('bankroll_user')
        setUser(null)
        setPendingAgreements([])
    }

    return (
        <AuthContext.Provider value={{
            user,
            isAuthenticated: !!user,
            pendingAgreements,
            login,
            logout,
            register,
            updateProfile,
            dismissAgreement,
        }}>
            {children}
        </AuthContext.Provider>
    )
}

export function useAuth() {
    return React.useContext(AuthContext)
}
